import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const UnderlineIcon = ({ fillColor }) => createIcon({
    displayName: 'UnderlineIcon',
    viewBox: '0 0 141 8',
    path: (_jsx("rect", { y: "2.38025", width: "140.004", height: "4.63498", transform: "rotate(-0.938602 0 2.38025)", fill: fillColor })),
});
//# sourceMappingURL=UnderlineIcon.js.map